<ey-froala-content-wrapper [editorContent]="body"></ey-froala-content-wrapper>
<ul class="ps-0 mt-10">
  <li class="segments d-flex" *ngFor="let f of files">
    <span class="flex-grow-1">{{ f.name }}</span> <i title="Download File" role="button" (click)="download(f)" class="icon-ico_download emp-icon"></i>
  </li>
</ul>
<span *ngIf="files?.length < 1">- Not Uploaded -</span>
